'use client';

import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { ContentContainer } from '@/components/ui/content-container.component';

interface HelpSearchHeroProps {
  value: string;
  onChange: (value: string) => void;
}

export const HelpSearchHero = ({ value, onChange }: HelpSearchHeroProps) => {
  return (
    <section
      className="bg-green-500 w-full lg:rounded-3xl lg:mx-auto lg:max-w-3xl xl:max-w-5xl 3xl:max-w-7xl flex flex-col gap-2.5 md:gap-3"
      data-testid={DataTestIdEnum.FAQ_HELP_SEARCH_HERO}
    >
      <ContentContainer className="my-6 lg:mx-10 lg:my-10 lg:max-w-3xl lg:w-auto">
        <Typography
          variant={TypographyVariant.TITLE}
          as="h2"
          className="text-white mb-3"
        >
          Como podemos te ajudar?
        </Typography>
        <div className="flex items-center gap-3 bg-white border border-gray-300 rounded-lg h-12 pl-4 pr-2">
          <input
            type="search"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Digite aqui sua dúvida"
            aria-label="Digite aqui sua dúvida"
            autoComplete="off"
            data-testid={DataTestIdEnum.FAQ_HELP_SEARCH_INPUT}
            className="flex-1 bg-transparent text-base text-gray-700 placeholder:text-gray-500 focus:outline-none"
          />
          <span
            aria-hidden="true"
            className="flex items-center justify-center p-2 text-gray-500"
          >
            <Icon icon={faMagnifyingGlass} className="w-5 h-5" />
          </span>
        </div>
      </ContentContainer>
    </section>
  );
};
